module.exports = __webpack_public_path__ + "static/media/c-unisex.d91145a1.png";